document.addEventListener('DOMContentLoaded', function() {
  document.body.addEventListener('click', function(e) {
    if (e.target.closest('.the4-mtf-data-icon-link')) {
      e.preventDefault();
      e.stopPropagation();
      
      const target = document.getElementById('specifications-section');
      if (target) {
        const header = document.querySelector('header') || document.querySelector('.header');
        const headerHeight = header ? header.offsetHeight : 0;
        
        const targetPosition = target.getBoundingClientRect().top + window.scrollY - headerHeight - 20;
        
        window.scrollTo({
          top: targetPosition,
          behavior: 'instant'
        });
      }
      
      return false;
    }
  });
});

